<div class="w-full flex flex-col gap-[6px]">
  <span class="font-[800] text-[14px] text-[#6B7280]">{{ label }}</span>
  <div appClickOutside (clickOutside)="close()" class="relative w-full">
    <div [ngClass]="selectedTitle ? 'text-[#374151]' : 'text-[#6B7280]'" 
      (click)="toggleDropdown()"
      class="w-full px-[13px] h-[52px] items-center bg-[#F4F5F7] rounded-[5px] text-left cursor-pointer justify-between flex"
    >
      {{selectedTitle ? selectedTitle : 'Select an Item'}}
      <img src="../../../assets/icons/chevron.svg" class="float-right" alt="" />
  </div>

    <div
      *ngIf="dropdownOpen"
      class="absolute w-full mt-1 bg-white border rounded-lg shadow-lg z-10"
    >
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (input)="filterItems()"
        placeholder="Search..."
        class="w-full p-3 border-b focus:outline-none"
      />

      <ul class="max-h-40 overflow-y-auto">
        <li
          *ngFor="let item of filteredItems"
          (click)="selectItem(item)"
          class="p-3 hover:bg-gray-100 cursor-pointer"
        >
          <strong>{{ item.name }}</strong>
          <p class="text-sm text-gray-500">{{ item.description }}</p>
        </li>
        <li *ngIf="filteredItems.length === 0" class="p-3 text-gray-500">
          No items found
        </li>
      </ul>
    </div>
  </div>
  <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div>
